import { Drawer } from "antd";
import { get } from "lodash";
import { MdOpenInNew } from "react-icons/md";
import Button from "shared/components/Button";
import Input from "shared/components/Input";
import { COLORS } from "shared/style/colors";
import { CURRENCY_SYMBOL } from "utils/constants";
import { costToFrench } from "utils/helpers/values";
import {
  computeUpsellPricing,
  isLumineisUpsells,
} from "utils/helpers/lumineisUpsells";

const ProductsDrawer = ({
  open,
  onClose,
  selectedInsurancePlans,
  selectedModules,
  onCheck,
  insurancePlan,
  cost,
  currency,
  disabled,
  translation,
  onOpenDetails,
}) => {
  const symbol = CURRENCY_SYMBOL[currency];
  const selected = get(selectedModules, insurancePlan.id, []);
  const uniqueData = Array.from(
    new Map(
      selectedInsurancePlans.map((item) => [item.insurancePlan.id, item]),
    ).values(),
  );
  const { total: upsellsTotal, costForModule } = computeUpsellPricing({
    modules: uniqueData,
    selectedModules: selected,
  });
  const totalCost = (cost + upsellsTotal)?.toFixed(2);
  const [integer, decimal = ""] = costToFrench(totalCost?.toString())?.split(
    ",",
  ) || ["-"];
  const showPackDiscountNote =
    isLumineisUpsells(uniqueData) && uniqueData.length >= 2;
  return (
    <Drawer
      className="drawer__area"
      title={get(translation, "UPSELLS.COMPLEMENTS_MANAGEMENT", "")}
      width={500}
      onClose={onClose}
      open={open}
      placement="right"
    >
      <div className="upsells__details">
        <div className="upsells__details--header">
          <div className="upsells__details--left">
            <img
              className="upsells__details--image"
              src={insurancePlan.icon}
              alt={insurancePlan.name}
            />
            <div className="upsells__details--name">{insurancePlan.name}</div>
          </div>
          <div className="upsells__details--right">
            <div className="insurance-plan__cost">
              <span className="insurance-plan__cost--integer">
                {`${integer} ${symbol} `}
                <span className="insurance-plan__cost--decimal">{`${decimal}`}</span>
              </span>
              <span className="insurance-plan__cost--period">{` /mois`}</span>
            </div>
            <span className="insurance-card__item--total">
              {`${(+totalCost * 12).toFixed(0)} ${symbol} / an `}
              <span>{get(translation, "UPSELLS.ALL_INCLUDED", "")}</span>
            </span>
          </div>
        </div>
        {showPackDiscountNote && (
          <div className="upsells__discount-note">
            {get(
              translation,
              "UPSELLS.PACK_DISCOUNT",
              "Réduction pack en cas de souscription des 2 packs",
            )}
          </div>
        )}
        <div className="upsells__details--body">
          {uniqueData
            ?.sort((a, b) =>
              get(a, "insurancePlan.name").localeCompare(
                get(b, "insurancePlan.name"),
              ),
            )
            ?.map((module) => {
              const [moduleInteger, moduleDecimal = ""] = costToFrench(
                costForModule(module)?.toString(),
              )?.split(",") || ["-"];
              const moduleSymbol = CURRENCY_SYMBOL[currency];
              return (
                <div
                  key={get(module, "insurancePlan.id")}
                  className="upsells__checkbox"
                >
                  <div className="upsells__checkbox--left">
                    <Input
                      type="checkbox"
                      label={get(module, "insurancePlan.name")}
                      onChange={() => onCheck(module)}
                      checked={
                        get(selectedModules, insurancePlan.id, []).find(
                          ({ insurancePlan: plan }) =>
                            plan?.id === get(module, "insurancePlan.id", ""),
                        ) || false
                      }
                      disabled={disabled}
                    />
                    <div
                      className="upsells__checkbox--button"
                      onClick={() =>
                        onOpenDetails(get(module, "insurancePlan.id"))
                      }
                    >
                      <MdOpenInNew size={16} color={COLORS.C_PRIMARY} />
                    </div>
                  </div>
                  <div className="upsells__details--right">
                    <div className="insurance-plan__cost">
                      <span className="upsells__details--integer">
                        {`${moduleInteger} ${moduleSymbol} `}
                        <sup>{`${moduleDecimal}`}</sup>
                      </span>
                      <span className="upsells__details--period">{` /mois`}</span>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        <Button type="primary" size="full--width" onClick={onClose}>
          {get(translation, "UPSELLS.SAVE_CLOSE", "")}
        </Button>
      </div>
    </Drawer>
  );
};

export default ProductsDrawer;
